function sortVariantsByBrand(variantMap, reverse) {
  const entries = Object.entries(variantMap);
  entries.sort(([, a], [, b]) => {
    const cmp = (a.brand || '').toLowerCase().localeCompare((b.brand || '').toLowerCase());
    return reverse ? -cmp : cmp;
  });
  return Object.fromEntries(entries);
}

function sortVariantsByMargin(variantMap, reverse) {
  const entries = Object.entries(variantMap);
  entries.sort(([, a], [, b]) => {
    // Variants with no margin data sort to the bottom regardless of direction.
    if (a.margin === null && b.margin === null) return 0;
    if (a.margin === null) return 1;
    if (b.margin === null) return -1;
    return reverse ? a.margin - b.margin : b.margin - a.margin;
  });
  return Object.fromEntries(entries);
}

function addCustomSortOptions() {
  const select = document.getElementById('sort-by-select');
  if (!select) { return; }

  const currentSort = new URLSearchParams(window.location.search).get('sort_by');
  [
    { value: 'brand-ascending',   label: 'Brand, A to Z' },
    { value: 'brand-descending',  label: 'Brand, Z to A' },
    { value: 'margin-descending', label: 'Margin, high to low' },
    { value: 'margin-ascending',  label: 'Margin, low to high' },
  ].forEach(({ value, label }) => {
    const opt = document.createElement('option');
    opt.value = value;
    opt.textContent = label;
    opt.selected = currentSort === value;
    select.appendChild(opt);
  });
}